import { useResizeObserver } from '@folklore/hooks';
import classNames from 'classnames';

import Image from '../partials/Image';
import ImageCaption from '../typography/ImageCaption';

import styles from '../../styles/blocks/image-block.module.css';

interface ImageBlockProps {
    media: ImageMedia;
    caption?: string | null;
    size?: string | null;
    presentation?: string | null;
    className?: string | null;
}

function ImageBlock({
    media,
    size = 'responsive',
    caption = null,
    presentation = null,
    className = null,
}: ImageBlockProps) {
    const { credits = null } = media || {};
    const { ref: refResize, entry: { contentRect = null } = {} } = useResizeObserver();
    const { width: containerWidth, height: containerHeight } = contentRect || {};

    return (
        <figure
            className={classNames([
                styles.container,
                {
                    [styles.withoutMaxHeight]: presentation === 'medium',
                    [styles.fullwidth]: presentation === 'full',
                    [className]: className !== null,
                },
            ])}
            ref={refResize}
        >
            <Image
                media={media}
                width={containerWidth}
                height={containerHeight}
                loading="lazy"
                size={size}
                alt={caption}
                withoutSize
                className={styles.image}
                pictureClassName={styles.picture}
            />
            {credits !== null ? <ImageCaption className={styles.credits} html={credits} /> : null}
            {caption !== null &&
            (credits === null || caption.substring(0, 30) !== credits.substring(0, 30)) ? (
                <ImageCaption
                    className={classNames([
                        styles.caption,
                        {
                            [styles.withCredits]: credits !== null,
                        },
                    ])}
                    html={caption}
                />
            ) : null}
        </figure>
    );
}

export default ImageBlock;
